import React from 'react';
import { RoutesCard } from './RoutesCard';
import styles from './RoutesSimpleSection.module.sass';

export const RoutesSimpleSection = ({ learningPath, routesProgress }) => {
  return (
    <section className={styles.RoutesSimpleSection} data-testid="RoutesSimpleSection">
      <div className={styles.Grid}>
        {learningPath.routes.map((item, index: number) => (
          <RoutesCard key={`routeCard-${index}`} progress={routesProgress[item.id]} {...item} />
        ))}
      </div>
    </section>
  );
};
